module.exports = __webpack_public_path__ + "img/log_send_front.ad264ddb.png";